export default {"src":"/_next/static/media/intro-step-icon-1.dcb3dd0c.svg","height":84,"width":82,"blurWidth":0,"blurHeight":0};